"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultSuccess = void 0;
const react_1 = __importDefault(require("react"));
const InlineMessage_1 = require("../../inline-message/InlineMessage");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const ResultSuccess = () => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Heading_1.HeadingSmall, null,
        react_1.default.createElement(InlineMessage_1.InlineMessage, { text: "Smart pricing activated! \uD83D\uDE80", icon: "check", display: "success" })),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null, "Your're now ready to price like a professional! Current listings will update across all booking channels shortly."),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null,
        react_1.default.createElement("strong", null, "Pro Tip:"),
        " Peek at your calendar weekly\u2014adjust for special events or last-minute opportunities. You're always in control."),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null,
        react_1.default.createElement("strong", null, "Do's & Don'ts for maximum earnings")),
    react_1.default.createElement("ul", null,
        react_1.default.createElement("li", null,
            react_1.default.createElement("strong", null, "\u2705 Do: Review weekly"),
            react_1.default.createElement("br", null),
            "Check your prices regularly help catch special events while smart pricing handle broader trends."),
        react_1.default.createElement("li", null,
            react_1.default.createElement("strong", null, "\u2705 Do: Adjust for unique situations"),
            react_1.default.createElement("br", null),
            "Wedding season? Festival weekend? Nudge your prices up via the calendar."),
        react_1.default.createElement("li", null,
            react_1.default.createElement("strong", null, "\u2705 Do: Watch your occupancy"),
            react_1.default.createElement("br", null),
            "Pricing has the greatest impact on your earnings"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement("li", null,
            react_1.default.createElement("strong", null, "\u274C Don't: Micromanage daily prices"),
            react_1.default.createElement("br", null),
            "Our algorithm spots demand patterns humans often miss, let it work for you."),
        react_1.default.createElement("li", null,
            react_1.default.createElement("strong", null, "\u274C Don't: Ignore recommendations"),
            react_1.default.createElement("br", null),
            "Check the pricing page for suggestions on how to maximize your earnings.")));
exports.ResultSuccess = ResultSuccess;
//# sourceMappingURL=ResultSuccess.js.map